import { authorizerTokenCookie, authorizerTokenCookieExpirationDate, } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
import { DateTime } from 'luxon';
import { setCookie } from './cookies';
export default function setAuthToken(token, expiryMinutes) {
    setCookie(authorizerTokenCookie, token, expiryMinutes);
    setCookie(authorizerTokenCookieExpirationDate, DateTime.local().plus({ minutes: expiryMinutes }).toISO() ?? '', expiryMinutes);
}
